<template>
    <div>
        <v-card-title class="justify-center text-h5">
            {{ $t("pricingSettingsLabel") }}
        </v-card-title>
        <PricingTable :prices="prices"/>
    </div>

<!--    <div>-->
<!--        <v-tabs vertical class="overflow-fix">-->
<!--            <v-tab class="d-flex justify-start text-wrap text-left">-->
<!--                {{ $t("pricingSettingsLabel") }}-->
<!--            </v-tab>-->
<!--&lt;!&ndash;            <v-tab class="d-flex justify-start text-wrap text-left">&ndash;&gt;-->
<!--&lt;!&ndash;                {{ $t("listOfUsersLabel") }}&ndash;&gt;-->
<!--&lt;!&ndash;            </v-tab>&ndash;&gt;-->

<!--            <v-tab-item>-->
<!--                <v-card class="pl-9" flat>-->
<!--                    <v-card-text class="pa-0">-->
<!--                        <div class="d-flex mb-5">-->
<!--                            <div class="black&#45;&#45;text text-h5">{{ $t("pricingSettingsLabel") }}</div>-->
<!--                        </div>-->
<!--                    </v-card-text>-->
<!--                    <PricingTable :prices="prices"/>-->
<!--                </v-card>-->
<!--            </v-tab-item>-->
<!--&lt;!&ndash;            <v-tab-item>&ndash;&gt;-->
<!--&lt;!&ndash;                <v-card class="pl-9" flat>&ndash;&gt;-->
<!--&lt;!&ndash;                    <v-card-text class="pa-0">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="d-flex mb-5 ">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="black&#45;&#45;text text-h5 text-center">{{ $t("listOfUsersLabel") }}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </v-card-text>&ndash;&gt;-->
<!--&lt;!&ndash;                    <PricingUsers :prices="prices"/>&ndash;&gt;-->
<!--&lt;!&ndash;                </v-card>&ndash;&gt;-->
<!--&lt;!&ndash;            </v-tab-item>&ndash;&gt;-->
<!--        </v-tabs>-->
<!--    </div>-->
</template>

<script>
    import PricingTable from "./PricingTable";
    import PricingUsers from "./PricingUsers";
    export default {
        name: "PricingBoard",
        components: {
            PricingTable: PricingTable,
            PricingUsers: PricingUsers
        },
        data() {
            return {
                prices: []
            }
        },
        methods: {
            getAllPrices() {
                this.axios.get("api/extra-charge")
                    .then((response) => {
                        this.prices = response.data;
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
        },
        mounted() {
            this.getAllPrices();
        }
    }
</script>

<style scoped>

</style>